<template>
  <div class="centered-area">
    <div class="rounded-area">
      <h2>よくある質問</h2>

      <h3 class="mb-4">
        内容や効果について
      </h3>
      <v-expansion-panels class="mb-4">
        <v-expansion-panel
          title="Q. ただ写すだけで学習になるのですか？"
          text="A. はい。写すだけでも、プログラムの長さと実現できる内容の感覚、どんな文字を打ったか（どんな文法を使ったか）、間違いなく打ち込むには何に気を付ければいいか、などが意識に刷り込まれていきます。そして、独自のプログラム開発に興味が沸いたら、それらを深堀りして正確な知識に変えていくことができます。"
        />
        <v-expansion-panel
          title="Q. Scratch に比べて何がよいのですか？"
          text="A. Scratch のようなブロックを組み立ててプログラミングをするビジュアルプログラミングは、初期学習者にとってはわかりやすいものです。しかし、ビジュアルプログラミングも見た目がブロックであるだけでプログラミング言語にほかなりません。また、本格的な開発になるといずれはテキストプログラミングに移行することがほとんどです。 Code & Magic では初めからテキストプログラミングを行います。テキストプログラミングから学び始める人もたくさんいます。"
        />
        <v-expansion-panel
          title="Q. 魔導書のプログラムを写すだけですか？独自のプログラムを作ることもできますか？"
          text="A. はい。羽根筆のゆりかごで、自由にプログラミングが可能です。つくれる数は魔導エネルギーを使って増やすことができます。画像や音楽の編集は今後のアップデートで対応予定です。"
        />
        <v-expansion-panel
          title="Q. わからないときに質問をすることはできますか？"
          text="A. 「女神にチェックしてもらう」という機能で、AIによりエラーチェックをしてもらうことができます。今後も、機能の拡張を予定しています。"
        />
        <v-expansion-panel
          title="Q. 業務効率化や資格取得のためのプログラミング学習にも使えますか？"
          text="A. いいえ。Code & Magic は業務効率化や資格取得を目的としたプログラミング学習サービスではありません。趣味としてゲーム制作を楽しむためのサービスです。業務目的のサービスをお探しの場合は、別途ご検討ください。"
        />
      </v-expansion-panels>

      <h3 class="mb-4">
        必要なものについて
      </h3>
      <v-expansion-panels class="mb-4">
        <v-expansion-panel
          title="Q. パソコンが必要ですか？スマートフォンやタブレットでもできますか？"
          text="A. パソコンの使用をお勧めします。ノートパソコンやデスクトップパソコンなどの種類は問いません。タブレットの場合は、外付けキーボードの使用をお勧めします。ソフトウェアキーボードでは画面が隠れてしまうため不便です。スマートフォンはご利用になれません。"
        />
        <v-expansion-panel
          title="Q. ゲームを作るなら、性能の良いパソコンが必要なのでしょうか？"
          text="A. いいえ、ウェブブラウザが快適に使えるパソコンであれば、問題なくお使いいただけます。 Code & Magic で作るゲームはレトロ風ゲームであるため、GPUなどの高度な機器は必要ありません。"
        />
        <v-expansion-panel
          title="Q. 英語がわからなくてもできますか？"
          text="A. はい、できます。アルファベットの区別がつけば、プログラミング言語の習得には問題ありません。むしろ、アルファベットや英単語の学習の機会になると考えられます。なお、将来プログラマーとして活躍するならば、英語がわかると世界中の情報を調べられるので有利になるでしょう。"
        />
        <v-expansion-panel
          title="Q. タッチタイピングができなくてもできますか？"
          text="A. はい、できます。キーボードのキー配置を覚えることも学習のうちです。なお、タッチタイピングを習得したい場合は、専用の訓練ソフトを使うのもおすすめです。"
        />
      </v-expansion-panels>

      <h3 class="mb-4">
        料金について
      </h3>
      <v-expansion-panels class="mb-4">
        <v-expansion-panel
          title="Q. どんな料金がかかりますか？"
          text="A. 基本料金と買い切り商品の組み合わせとなります。基本料金は月額課金で現在は無料プランのみです。買い切り商品はエリアの魔導書の入手などです。料金については断りなく変更する場合がございます。"
        />
        <v-expansion-panel
          title="Q. どのような支払方法に対応していますか？"
          text="A. 各種クレジットカードに対応しています。支払いは世界中で大きなシェアを持つ Stripe 社のシステムを使っており、暗号化などのセキュリティを用いて安全に決済が行われます。クレジットカード情報は Stripe のみが管理し、当社には伝わりません。配送先住所氏名のみが伝わります。"
        />
        <!-- <v-expansion-panel title="Q. 兄弟姉妹がいます。エリアの魔導書は紙なので共用してもいいですか？"
                        text="A. はい。エリアの魔導書は、兄弟姉妹で共用していただけます。同じ親アカウントを持つ子アカウントであれば、３回（３人）まで魔導書をお使いいただけます。">
                    </v-expansion-panel>
                    <v-expansion-panel title="Q. 子供にアカウントを持たせたいですが、勝手に購入してしまうのを避ける方法はありますか？"
                        text="A. はい。子アカウントの利用をお勧めします。子アカウントは、メールアドレス不要で、購入機能が利用できません。子アカウントの作成は、親アカウントのメニューから行えます。">
                    </v-expansion-panel> -->
      </v-expansion-panels>

      <h3 class="mb-4">
        ライセンス表示
      </h3>
      <v-expansion-panels>
        <v-expansion-panel title="Code & Magic で使用しているライブラリやアセットのライセンス表示">
          <v-expansion-panel-text>
            <template #default>
              <ul>
                <li>
                  <NuxtLink to="/licenses/PYXEL">Pyxel (Takashi Kitao)</NuxtLink>
                </li>
                <li>
                  <NuxtLink to="/licenses/MPLUS_FONTS">M+ FONTS (The M+ FONTS Project Authors)</NuxtLink>
                </li>
              </ul>
            </template>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<style scoped>
.centered-area {
  width: 100%;
  height: 100%;
  max-width: var(--landing-max-width);
  margin: auto;
  padding: var(--landing-gutter);
}

h2 {
  color: var(--landing-color-navy);
  font-size: var(--landing-h2-size);
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.centered-area h3 {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: var(--landing-h3-size);
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.5em;
}

.rounded-area {
  margin: 0 0.5em;
  padding: var(--landing-rounded-padding);

  background-color: var(--landing-color-card-warm);

  border-radius: var(--landing-radius);
  box-shadow: var(--landing-shadow);
}

.centered-area p {
  margin-bottom: 0.5em;
}

.centered-area ul {
  padding-left: 1.5em;
}
</style>
